<div class="modal--container">
  <div class="modal-body">
    <div class="close-button--container">
      <span class="modal-title">Edit Licence Type</span>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="close"
        ariaLabel="Close"
        (buttonClicked)="close()"
      ></app-mat-icon-button>
    </div>
    <form [formGroup]="licenceTypeForm" (ngSubmit)="onSubmit()">
      <app-underlined-dropdown-form-field
        [field]="licenceTypeField"
        [parentForm]="licenceTypeForm"
      ></app-underlined-dropdown-form-field>
      @if (selectedLimits()) {
        <div class="limit-cards" aria-live="polite" aria-atomic="true">
          <app-licence-card
            label="Users"
            [currentValue]="numberOfUsers()"
            [maxValue]="selectedLimits().maxUsers"
            [showBar]="isUsersLimited()"
            [barPercent]="usersBarPercent()"
            [isOverLimit]="isUsersOverLimit()"
          ></app-licence-card>
          <app-licence-card
            label="Devices"
            [currentValue]="numberOfDevices()"
            [maxValue]="selectedLimits().maxDevices"
            [showBar]="isDevicesLimited()"
            [barPercent]="devicesBarPercent()"
            [isOverLimit]="isDevicesOverLimit()"
          ></app-licence-card>
        </div>
        @if (isOverLimit()) {
          <div class="downgrade-warning" role="alert">
            <mat-icon aria-hidden="true">warning</mat-icon>
            <div>
              <p class="downgrade-warning__title">Licence downgrade warning</p>
              <p class="downgrade-warning__body">
                {{ overLimitWarningText() }}
              </p>
            </div>
          </div>
        }
      }
      <div class="button--container">
        <app-button
          buttonStyle="secondary"
          label="Cancel"
          buttonId="cancel-licence-type"
          [isDisabled]="processing()"
          (buttonClicked)="close()"
        ></app-button>
        <app-button
          buttonType="submit"
          buttonStyle="standard"
          label="Save"
          buttonId="save-licence-type"
          [isProcessing]="processing()"
          [isDisabled]="
            licenceTypeForm.invalid || isOverLimit() || processing()
          "
        ></app-button>
      </div>
    </form>
  </div>
</div>
<div class="modal--backdrop"></div>
